var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-file-input', {
    attrs: {
      "id": "file-selector",
      "clearable": "",
      "dense": "",
      "error-messages": _vm.fileUploadError,
      "label": "Select network file",
      "outlined": "",
      "prepend-icon": "",
      "prepend-inner-icon": "mdi-paperclip",
      "single-line": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })], 1), _c('v-flex', {
    staticClass: "pl-2",
    attrs: {
      "xs6": ""
    }
  }, [_vm.fileTypes.length ? _c('v-select', {
    staticClass: "file-type",
    attrs: {
      "id": "file-type",
      "dense": "",
      "hint": _vm.selectedType ? _vm.selectedType.hint : null,
      "items": _vm.fileTypes,
      "item-text": "displayName",
      "item-value": "displayName",
      "label": "File type",
      "outlined": "",
      "persistent-hint": "",
      "return-object": ""
    },
    model: {
      value: _vm.selectedType,
      callback: function ($$v) {
        _vm.selectedType = $$v;
      },
      expression: "selectedType"
    }
  }) : _vm._e()], 1)], 1), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "id": "table-name",
      "dense": "",
      "error-messages": _vm.tableCreationError,
      "label": "Network name",
      "outlined": ""
    },
    model: {
      value: _vm.fileName,
      callback: function ($$v) {
        _vm.fileName = $$v;
      },
      expression: "fileName"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "id": "create-table",
      "disabled": _vm.createDisabled
    },
    on: {
      "click": _vm.createNetwork
    }
  }, [_vm._v(" Upload ")])], 1), _vm.uploading ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadProgress
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }